import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfiguration } from '../api-configuration';
import { Observable, catchError, of, throwError } from 'rxjs';
import { PagedListInputRequest, AllProductsComparator, EditProductRequest, LogsComparacao, Competitor, AdicionarProdutoComparacao, AddProductResult, Laboratory } from '../models/product-comparator';

@Injectable({
  providedIn: 'root'
})
export class ProductComparatorService{
  route = new ApiConfiguration();
  ApiProductComparatorGetPath = this.route.rootUrl + '/api/comparador';

  constructor(private http: HttpClient) { 
  }

  addProductToComparator(products: AdicionarProdutoComparacao){
    return this.http.post<AddProductResult>(this.ApiProductComparatorGetPath + '/add-product-comparator', products)
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
  
  getComparation(pagedListInput: PagedListInputRequest, selectedStoreFilter: number[]): Observable<AllProductsComparator> {
    let params = new HttpParams()
      .append('Page', String(pagedListInput.Page))
      .append('PageSize', String(pagedListInput.PageSize))
      .append('SortColumn', pagedListInput.SortColumn || '')
      .append('SortOrder', pagedListInput.SortOrder || '')
      .append('FilterName', pagedListInput.FilterName || '')
      .append('FilterValue', pagedListInput.FilterValue || '')
    selectedStoreFilter.forEach(id => {
        params = params.append('competitorsId', String(id));
    });
    return this.http.get<AllProductsComparator>(this.ApiProductComparatorGetPath, {params})
    .pipe(
      catchError((error) => {
        console.error(error);
        return of({
          data: [],
          totalCount: 0,
          hasNextPage: false
        } as AllProductsComparator);
      })
    );
  }

  updateProduct(productData: EditProductRequest){
    return this.http.put<void>(this.ApiProductComparatorGetPath + '/update-product-data', productData)
    .pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  getProductLogs(product_id: string){
    let params = new HttpParams().append('product_id', product_id);
    return this.http.get<LogsComparacao[]>(this.ApiProductComparatorGetPath + '/get-product-logs', { params })
    .pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  getCompetitor(){
    return this.http.get<Competitor[]>(this.ApiProductComparatorGetPath + '/get-competitors')
    .pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  getLaboratory(){
    return this.http.get<Laboratory[]>(this.ApiProductComparatorGetPath + '/get-laboratories')
    .pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    )
  }

  downloadFile(pagedList: PagedListInputRequest, selectedStoreFilter: number[]) {
    let params = new HttpParams()
      .append('Page', String(pagedList.Page))
      .append('PageSize', String(pagedList.PageSize))
      .append('SortColumn', pagedList.SortColumn || '')
      .append('SortOrder', pagedList.SortOrder || '')
      .append('FilterName', pagedList.FilterName || '')
      .append('FilterValue', pagedList.FilterValue || '')
    selectedStoreFilter.forEach(id => {
        params = params.append('competitorsId', String(id));
    });
    return this.http.get<any>(this.ApiProductComparatorGetPath + '/export',
      {
        params, 
        responseType: 'blob' as 'json', 
        observe: 'response'
      })
    .pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    )
  }
}
